/**   
 * api接口统一管理
 */
import { get, post, axiosPost } from './http';

//人脸列表
export const facePage = p => axiosPost(`/bizFaceCapture/findPage`, p);
//人脸列表
export const faceSearch = p => axiosPost(`/bizFaceCapture/captureSearch`, p);
//实时车位
// export const realParking = p => post(`/staRealParking/getRealTimeData`, p);
export const realParking = p => post(`/staCarAnalysis2/getParkingCount`, p);
//实时设备状态
export const realDevice = p => post(`/staRealDevice/getRealTimeData`, p);
//实时在园人数统计
export const realPassenger = p => post(`/staRealPassenger/getRealTimeData`, p);
//实时厕所使用统计
export const realToilet = p => post(`/staRealToilet/getRealTimeData`, p);
//客流趋势
export const getTrendby = p => post(`/staPassengerAnalysis/getTrendByTimeValue`, p);
//首页在园人数统计 
export const realCustomer = p => post(`/staRealPassenger/getRealWithSellAndFlow`, p);
// 客流高峰预计
export const maxCustomer = p => post(`/staPassengerAnalysis/getEstimate`, p);
//设备统计
export const equipCount = p => post(`/staRealDevice/getRealTimeData`, p);
// 首页环境 实时监测
export const weatherLook = p => post(`/bizEnvAtmosphericHumidity/findWeatherInfo`, p);
// 首页环境 预警信息查询
export const weatherAlertPage = p => post(`/bizWarningWeather/findByThreshold`, p);
// 首页环境 折线图
export const weatherLineChart = p => post(`/bizEnvAtmosphericHumidity/findWeather`, p);
// 地质 折线图
export const placeChart = p => post(`/staDisplacement/findDisList`, p);
// 地质详情
export const placeInfo = p => post(`/staDisplacement/findDisInfo`, p);
// 字典组
export const getChildGrop = p => post(`/sysDictionaryGroup/findChildren`, p);
// 字典
export const getZiDian = p => post(`/sysDictionary/findPage`, p);

// 首页安检
export const getAnjian = p => post(`/bizSecuritySituation/findPage`, p);

// 停车场分析
export const CarParkaAnalysis = p => post(`/bizParkingOut/findPage`, p);
// 停车场过车记录
export const CarParkRecord = p => post(`/bizParkingOut/findPage`, p);

// 停车场过车记录
export const CarParkRecordInOut = p => post(`/bizParkingOut/findInOutPage`, p);
// 停车场下拉选择
export const CarParkList = p => post(`/resEntityBaseInfo/findPage`, p);
// wifi列表
export const wifiList = p => post(`/bizWifiProbe/findPage`, p);
// 环境数据
export const enviromentData = p => post(`/bizEnv/findPage`, p);

// 停车场分析
// 车流趋势
export const carTrendy = p => post(`/staCarAnalysis/getTrendByTimeValue`, p);
// 车流时段分布
export const TimeDistribute = p => post(`/staCarAnalysis/getHourDistributeByTimeValue`, p);
// 车源地top10省份
export const top10carResourceP = p => post(`/staCarAnalysis/getSourceProvinceByTimeValue`, p);
export const top10carResourceC = p => post(`/staCarAnalysis/getSourceCityByTimeValue`, p);

//客流同比
export const getYOYTrendByTimes = p => post(`/staPassengerAnalysis/getYOYTrendByTimes`, p);
//客流性别占比
export const getSexByTimes = p => post(`/staPassengerAnalysis/getSexByTimes`, p);
//客流年龄占比
export const getAgeByTimes = p => post(`/staPassengerAnalysis/getAgeByTimes`, p);
//团散票占比
export const getGroupDataByTimeValue = p => post(`/staTicketSell/getGroupDataByTimes`, p);
//票型占比
export const getTypeByTimes = p => post(`/staTicketSell/getTypeByTimes`, p);

// 售票数据
export const getTicketSellByTimes = p => post(`/staTicketSell/getTypeDataByTimes`, p);
// 售票同比
export const getYOYTicketSellByTimes = p => post(`/staTicketSell/getYOYTrendByTimes`, p);
// 签到--签到记录
export const getSignList = p => axiosPost(`/supplemental-api/supplemental/bizUserSignIn/list
`, p);

// 启动播放
export const startBroadcastTask = p => axiosPost(`/supplemental-api/supplemental/broadcastTask/start
`, p);

// 停止播放
export const stopBroadcastTask = p => axiosPost(`/supplemental-api/supplemental/broadcastTask/stop
`, p);